import { PORTFOLIOS, ROLES } from ".";

const usePermition = ({ user }) => {
  const hasRole = (roleName) => {
    return !!user?.roles.find((rol) => rol.name === roleName);
  };

  /**
   * Para cada vista se establece la visibilidad de los botones dependiendo de la cartera y los roles de usuario
   */
  const PERMISOS_POR_ROL = {
    Inicio: {
      Tabla:
        user?.currentPortfolioID !== PORTFOLIOS.PARTICULARES &&
        hasRole(ROLES.CONTENT_EDITOR),
    },
    Buscador: {
      Acceso: true,
      CrearProducto:
        ((user?.currentPortfolioID !== PORTFOLIOS.PARTICULARES &&
          (hasRole(ROLES.SUPERADMIN) ||
            hasRole(ROLES.ADMIN) ||
            hasRole(ROLES.COMMERCIAL_DELEGATE) ||
            hasRole(ROLES.BUSINESS_MANAGER))) ||
          (user?.currentPortfolioID === PORTFOLIOS.PARTICULARES &&
            (hasRole(ROLES.ADMIN) ||
              hasRole(ROLES.SUPERADMIN) ||
              hasRole(ROLES.PARTICULAR)))) &&
        !hasRole(ROLES.READONLY),
      ValidarCreacionProducto: true,
      BuscarProductosBorrados: hasRole(ROLES.SUPERADMIN),
      CrearActivo:
        !hasRole(ROLES.READONLY) &&
        (user?.currentPortfolioID === PORTFOLIOS.PARTICULARES ||
          user?.currentPortfolioID === PORTFOLIOS.TERCEROS) &&
        (hasRole(ROLES.ADMIN) ||
          hasRole(ROLES.SUPERADMIN) ||
          hasRole(ROLES.PARTICULAR)),
      SuperAdmin: hasRole(ROLES.SUPERADMIN),
    },
    Publicaciones: {
      Acceso:
        user?.currentPortfolioID !== PORTFOLIOS.PARTICULARES &&
        user?.currentPortfolioID !== PORTFOLIOS.NPL_ANTICIPA &&
        user?.currentPortfolioID !== PORTFOLIOS.NPL_SAREB &&
        user?.currentPortfolioID !== PORTFOLIOS.NPL_QUASAR &&
        user?.currentPortfolioID !== PORTFOLIOS.NPL_TERCEROS,
    },
    Administracion: {
      Acceso: hasRole(ROLES.SUPERADMIN),
    },
    DetalleActivoParticular: {
      Acceso:
        user?.currentPortfolioID === PORTFOLIOS.PARTICULARES ||
        user?.currentPortfolioID === PORTFOLIOS.TERCEROS,
      Auditoria: hasRole(ROLES.SUPERADMIN),
      Guardar:
        !hasRole(ROLES.READONLY) &&
        (hasRole(ROLES.ADMIN) ||
          hasRole(ROLES.SUPERADMIN) ||
          hasRole(ROLES.PARTICULAR)),
    },
    DetalleActivo: {
      Acceso: true,
      EnviarTablaTemporal:
        !hasRole(ROLES.READONLY) && hasRole(ROLES.SUPERADMIN),
      Auditoria: hasRole(ROLES.SUPERADMIN),
      Guardar:
        !hasRole(ROLES.READONLY) &&
        (hasRole(ROLES.ADMIN) ||
          hasRole(ROLES.SUPERADMIN) ||
          hasRole(ROLES.COMMERCIAL_DELEGATE) ||
          hasRole(ROLES.CONTENT_EDITOR) ||
          hasRole(ROLES.BUSINESS_MANAGER)),
      OcultarNumero:
        !hasRole(ROLES.READONLY) &&
        (hasRole(ROLES.SUPERADMIN) || hasRole(ROLES.CONTENT_EDITOR)),
    },
    DetalleProducto: {
      Acceso: true,
      Auditoria: hasRole(ROLES.SUPERADMIN),
      ValidarProducto: true,
      Guardar:
        ((user?.currentPortfolioID !== PORTFOLIOS.PARTICULARES &&
          user?.currentPortfolioID !== PORTFOLIOS.TERCEROS &&
          (hasRole(ROLES.SUPERADMIN) ||
            hasRole(ROLES.ADMIN) ||
            hasRole(ROLES.COMMERCIAL_DELEGATE) ||
            hasRole(ROLES.BUSINESS_MANAGER) ||
            hasRole(ROLES.CONTENT_EDITOR))) ||
          (user?.currentPortfolioID === PORTFOLIOS.PARTICULARES &&
            (hasRole(ROLES.ADMIN) ||
              hasRole(ROLES.SUPERADMIN) ||
              hasRole(ROLES.PARTICULAR))) ||
          (user?.currentPortfolioID === PORTFOLIOS.TERCEROS &&
            (hasRole(ROLES.ADMIN) ||
              hasRole(ROLES.SUPERADMIN) ||
              hasRole(ROLES.TERCEROS)))) &&
        !hasRole(ROLES.READONLY),
      EnviarTablaTemporal:
        user?.currentPortfolioID !== PORTFOLIOS.PARTICULARES &&
        user?.currentPortfolioID !== PORTFOLIOS.TERCEROS &&
        !hasRole(ROLES.READONLY) &&
        hasRole(ROLES.SUPERADMIN),
      OcultarNumero:
        !hasRole(ROLES.READONLY) &&
        (hasRole(ROLES.SUPERADMIN) || hasRole(ROLES.CONTENT_EDITOR)),
      ProcesoTransparencia:
        !hasRole(ROLES.READONLY) &&
        (hasRole(ROLES.SUPERADMIN) ||
          hasRole(ROLES.ADMIN) ||
          hasRole(ROLES.COMMERCIAL_DELEGATE)),
    },
    Campanas: {
      Acceso:
        user?.currentPortfolioID !== PORTFOLIOS.PARTICULARES &&
        user?.currentPortfolioID !== PORTFOLIOS.TERCEROS,
      CrudCampana:
        !hasRole(ROLES.READONLY) &&
        (hasRole(ROLES.ADMIN) ||
          hasRole(ROLES.SUPERADMIN) ||
          hasRole(ROLES.MARKETING)),
      Auditoria: hasRole(ROLES.SUPERADMIN),
    },
    Promociones: {
      Acceso: user?.currentPortfolioID !== PORTFOLIOS.PARTICULARES,
      CrudPromocion:
        !hasRole(ROLES.READONLY) &&
        (hasRole(ROLES.ADMIN) ||
          hasRole(ROLES.SUPERADMIN) ||
          hasRole(ROLES.CONTENT_EDITOR)),
      Auditoria: hasRole(ROLES.SUPERADMIN),
      EnviarTablaTemporal:
        user?.currentPortfolioID !== PORTFOLIOS.TERCEROS &&
        !hasRole(ROLES.READONLY) &&
        hasRole(ROLES.SUPERADMIN),
    },
    CargasMasivas: {
      Acceso:
        user?.currentPortfolioID !== PORTFOLIOS.PARTICULARES &&
        user?.currentPortfolioID !== PORTFOLIOS.NPL_ANTICIPA &&
        user?.currentPortfolioID !== PORTFOLIOS.NPL_SAREB &&
        user?.currentPortfolioID !== PORTFOLIOS.NPL_QUASAR,
      Upload:
        !hasRole(ROLES.READONLY) &&
        (hasRole(ROLES.ADMIN) ||
          hasRole(ROLES.SUPERADMIN) ||
          hasRole(ROLES.CONTENT_EDITOR) ||
          hasRole(ROLES.MARKETING)),
      AsociarActivos:
        hasRole(ROLES.ADMIN) ||
        hasRole(ROLES.SUPERADMIN) ||
        hasRole(ROLES.CONTENT_EDITOR) ||
        hasRole(ROLES.MARKETING),
    },
    Territoriales: {
      Acceso: hasRole(ROLES.SUPERADMIN),
      Crud: !hasRole(ROLES.READONLY) && hasRole(ROLES.SUPERADMIN),
      Auditoria: hasRole(ROLES.SUPERADMIN),
    },
    Delegaciones: {
      Acceso: hasRole(ROLES.SUPERADMIN),
      Crud: !hasRole(ROLES.READONLY) && hasRole(ROLES.SUPERADMIN),
      Auditoria: hasRole(ROLES.SUPERADMIN),
    },
    SociedadesGestoras: {
      Acceso: hasRole(ROLES.SUPERADMIN),
      Crud: !hasRole(ROLES.READONLY) && hasRole(ROLES.SUPERADMIN),
      Auditoria: hasRole(ROLES.SUPERADMIN),
    },
    Usuarios: {
      Acceso: hasRole(ROLES.SUPERADMIN),
      Crud: !hasRole(ROLES.READONLY) && hasRole(ROLES.SUPERADMIN),
      Auditoria: hasRole(ROLES.SUPERADMIN),
    },
    Tareas: {
      Acceso: hasRole(ROLES.SUPERADMIN),
    },
    TablaTemporal: {
      Acceso: hasRole(ROLES.SUPERADMIN),
    },
    VentaEspecial: {
      Acceso: hasRole(ROLES.SUPERADMIN),
      Crud: !hasRole(ROLES.READONLY) && hasRole(ROLES.SUPERADMIN),
      Auditoria: hasRole(ROLES.SUPERADMIN),
    },
    Auditoria: {
      Acceso: hasRole(ROLES.SUPERADMIN),
    },
    SuperAdmin: hasRole(ROLES.SUPERADMIN),
    Admin: hasRole(ROLES.ADMIN),
    AnyAdmin:
      hasRole(ROLES.SUPERADMIN) ||
      hasRole(ROLES.ADMIN) ||
      hasRole(ROLES.BUSINESS_MANAGER),
    ComercialDelegate: hasRole(ROLES.COMMERCIAL_DELEGATE),
    BusinessManager: hasRole(ROLES.BUSINESS_MANAGER),
    ReadOnly: hasRole(ROLES.READONLY),
    ContentEditor: hasRole(ROLES.CONTENT_EDITOR),
    Marketing: hasRole(ROLES.MARKETING),
    Private: hasRole(ROLES.PARTICULAR),
  };

  return {
    PERMISOS_POR_ROL,
  };
};

export default usePermition;
